"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilteredItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_jss_1 = __importDefault(require("react-jss"));
const scroll_1 = require("../../../utils/scroll");
const filteredItem_style_1 = __importDefault(require("./filteredItem.style"));
const FilteredItem = ({ classes, index, value, label, prefix, transformedLabel, onSelect, isActive, activate, isSelected }) => {
    const itemRef = react_1.useRef(null);
    const onClick = react_1.useCallback(() => onSelect(value), [onSelect, value]);
    const onEnter = react_1.useCallback(() => activate(index), [activate, index]);
    react_1.useEffect(() => {
        if (isActive) {
            scroll_1.scrollToRef(itemRef);
        }
    }, [isActive]);
    return (jsx_runtime_1.jsxs("li", Object.assign({ ref: itemRef, className: classes.item, "data-is-active": isActive, "data-is-selected": isSelected, onMouseEnter: onEnter, onClick: onClick, title: label }, { children: [prefix && jsx_runtime_1.jsx("span", Object.assign({ className: classes.prefix }, { children: prefix }), void 0), transformedLabel] }), void 0));
};
exports.FilteredItem = FilteredItem;
exports.default = react_jss_1.default(filteredItem_style_1.default)(react_1.memo(exports.FilteredItem));
//# sourceMappingURL=index.js.map